<template>
    <input
        v-if="
            filter.current_shortcut_key != 'is_done' &&
            filter.current_shortcut_key != 'created_duration'
        "
        @keypress.enter="$parent.$parent.$parent.operations_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.operations.'+
                ((filter.current_shortcut_key != 'customer_note') ? filter.current_shortcut_key : 'your_note')
            )
        })"
        type="text"
    >
    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'created_duration'"
        v-model="filter.columns.created_duration"
        style="min-width: 200px;width:100%;"
        type="daterange"
        format="YYYY-MM-DD"
        key="created_duration">
    </DatePicker>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "OperationsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.operations_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>
